(function () {
    'use strict';

    angular.module('elogbooks.admin.sectors', []);
})();
